module.exports = __webpack_public_path__ + "static/img/google_ads_masterclass_1200x628-01.d57afed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/google_ads_masterclass_1200x628-01.png
// module id = M/7m
// module chunks = 1